import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@sainsburys-tech/fable'
import logger from '../../../utils/logger'
import api from '../../../utils/api'

import '../../../sass/components/handback-pass-modal.scss'

class HandBackPassModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      reason: null,
      isJobCompleted: null,
      isFireWatchCompleted: null,
      isReasonCompleted: null,
      fireWatchCompletedBy: null,
      isFireWatchNameCompleted: null
    }
  }

  componentDidUpdate(prevProps) {
    const { open } = this.props

    if (open && !prevProps.open) {
      document.addEventListener('keydown', this.handleEscape)
    }

    if (!open && prevProps.open) {
      document.removeEventListener('keydown', this.handleEscape)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscape)
  }

  handleEscape = (event) => {
    if (event.key === 'Escape') {
      this.clearStateAndHandleClose()
    }
  }

  handleOverlayMouseDown = (event) => {
    if (event.target === event.currentTarget) {
      this.clearStateAndHandleClose()
    }
  }

  handleReasonChange = (e) => {
    this.setState({ reason: e.target.value.trim() })
    if (e.target.value === '') {
      this.setState({ isReasonCompleted: false })
    } else {
      this.setState({ isReasonCompleted: true })
    }
  }

  handleFireWatchNameChange = (e) => {
    this.setState({ fireWatchCompletedBy: e.target.value.trim() })
    if (e.target.value === '' || e.target.value.length < 3) {
      this.setState({ isFireWatchNameCompleted: false })
    } else {
      this.setState({ isFireWatchNameCompleted: true })
    }
  }

  handleRadioButtonChange = (e) => {
    const radioButtonName = e.target.name
    const selection = parseInt(e.target.value, 10)
    if (radioButtonName === 'rbJobCompletion') {
      this.setState({ isJobCompleted: selection, isReasonCompleted: false })
    }
    if (radioButtonName === 'rbFireWatchCompletion') {
      this.setState({ isFireWatchCompleted: selection, isFireWatchNameCompleted: false })
    }
  }

  enableButtonCheck = () => {
    const {
      isJobCompleted,
      isFireWatchCompleted,
      isReasonCompleted,
      isFireWatchNameCompleted
    } = this.state

    const { hasFireWatchHandbackQuestions } = this.props

    if (isJobCompleted && isFireWatchCompleted === null && !hasFireWatchHandbackQuestions) {
      return false
    }
    if (!isJobCompleted && isReasonCompleted && isFireWatchCompleted === null && !hasFireWatchHandbackQuestions) {
      return false
    }
    if (isJobCompleted && isFireWatchCompleted) {
      return false
    }
    if (isJobCompleted && !isFireWatchCompleted && isFireWatchNameCompleted) {
      return false
    }
    if (!isJobCompleted && isFireWatchCompleted && isReasonCompleted) {
      return false
    }
    if (!isJobCompleted && !isFireWatchCompleted && isReasonCompleted && isFireWatchNameCompleted) {
      return false
    }
    return true
  }

  submitHandBackPass = () => {
    const {
      visitId, workOrderNumber, closeHandBackModal, loadingCallback
    } = this.props
    const {
      reason, isJobCompleted, isFireWatchCompleted, fireWatchCompletedBy
    } = this.state

    const handBackPass = {
      visitId,
      workOrderNumber,
      isJobCompleted,
      reason: reason !== null && reason.length > 0 ? reason : null,
      autoHandBack: false,
      isFireWatchCompleted,
      fireWatchCompletedBy
    }

    loadingCallback(true)

    api.submitHandBackPasses(handBackPass)
      .then((response) => {
        if (response === 1) {
          closeHandBackModal()
        }
        loadingCallback(false)
      }).catch((e) => { logger.logError(`An error occured handing back passes: ${e}`) })
  }

  clearStateAndHandleClose = () => {
    const { handleClose } = this.props

    this.setState(
      {
        reason: '',
        isJobCompleted: null,
        isFireWatchCompleted: null,
        isReasonCompleted: null,
        fireWatchCompletedBy: null,
        isFireWatchNameCompleted: null
      }
    )

    handleClose()
  }

  render() {
    const {
      open,
      title,
      isPlural,
      hasFireWatchHandbackQuestions
    } = this.props

    if (!open) {
      return null
    }

    const {
      isJobCompleted,
      isFireWatchCompleted,
      reason,
      fireWatchCompletedBy
    } = this.state

    const headingId = 'dsib-handBackPassModal-title'

    return (
      <div
        className="dsib-handBackPassModalOverlay"
        aria-hidden="false"
        onMouseDown={this.handleOverlayMouseDown}
      >
        <div
          className="dsib-handBackPassModalDialog"
          role="dialog"
          aria-modal="true"
          aria-labelledby={headingId}
        >
          <div className="dsib-handBackPassModalHeader">
            <h2 className="dsib-handBackPassModalTitle" id={headingId}>
              {`Hand back ${title}`}
            </h2>
            <button
              type="button"
              className="dsib-handBackPassModalClose"
              aria-label="Close"
              onClick={this.clearStateAndHandleClose}
            >
              ×
            </button>
          </div>

          <div className="dsib-handBackPassModalBody">
            <p className="dsib-handBackPassModalText">
              {`Please select an option below before handing back ${isPlural ? 'these' : 'this'} ${title}:`}
            </p>

            <fieldset className="dsib-handBackPassModalFieldset">
              <legend className="dsib-handBackPassModalLegend">Job completion</legend>

              <label
                className={`dsib-handBackPassModalOption ${isJobCompleted === 1 ? 'dsib-handBackPassModalOption--selected' : ''}`}
              >
                <input
                  className="dsib-handBackPassModalRadio"
                  type="radio"
                  name="rbJobCompletion"
                  value={1}
                  checked={isJobCompleted === 1}
                  onChange={this.handleRadioButtonChange}
                />
                <span className="dsib-handBackPassModalOptionText">Job completed</span>
              </label>

              <label
                className={`dsib-handBackPassModalOption ${isJobCompleted === 0 ? 'dsib-handBackPassModalOption--selected' : ''}`}
              >
                <input
                  className="dsib-handBackPassModalRadio"
                  type="radio"
                  name="rbJobCompletion"
                  value={0}
                  checked={isJobCompleted === 0}
                  onChange={this.handleRadioButtonChange}
                />
                <span className="dsib-handBackPassModalOptionText">Job not yet completed</span>
              </label>
            </fieldset>

            {isJobCompleted !== null && isJobCompleted === 0 ? (
              <div className="dsib-handBackPassModalIndented">
                <label className="dsib-handBackPassModalLabel" htmlFor="dsib-handback-reason">
                  Please enter your reason
                </label>
                <textarea
                  id="dsib-handback-reason"
                  className="dsib-handBackPassModalTextarea"
                  maxLength={250}
                  value={reason || ''}
                  onChange={this.handleReasonChange}
                />
              </div>
            ) : null}

            {hasFireWatchHandbackQuestions ? (
              <div className="dsib-handBackPassModalSection">
                <p className="dsib-handBackPassModalText">
                  Have you completed the required fire watches?
                </p>

                <fieldset className="dsib-handBackPassModalFieldset">
                  <legend className="dsib-handBackPassModalLegend">Fire watch completion</legend>

                  <label
                    className={`dsib-handBackPassModalOption ${isFireWatchCompleted === 1 ? 'dsib-handBackPassModalOption--selected' : ''}`}
                  >
                    <input
                      className="dsib-handBackPassModalRadio"
                      type="radio"
                      name="rbFireWatchCompletion"
                      value={1}
                      checked={isFireWatchCompleted === 1}
                      onChange={this.handleRadioButtonChange}
                    />
                    <span className="dsib-handBackPassModalOptionText">Yes, I completed them</span>
                  </label>

                  <label
                    className={`dsib-handBackPassModalOption ${isFireWatchCompleted === 0 ? 'dsib-handBackPassModalOption--selected' : ''}`}
                  >
                    <input
                      className="dsib-handBackPassModalRadio"
                      type="radio"
                      name="rbFireWatchCompletion"
                      value={0}
                      checked={isFireWatchCompleted === 0}
                      onChange={this.handleRadioButtonChange}
                    />
                    <span className="dsib-handBackPassModalOptionText">No, someone else completed them</span>
                  </label>
                </fieldset>

                {isFireWatchCompleted !== null && isFireWatchCompleted === 0 ? (
                  <div className="dsib-handBackPassModalIndented">
                    <label className="dsib-handBackPassModalLabel" htmlFor="dsib-handback-firewatch-name">
                      Full name of person that did fire watch
                    </label>
                    <input
                      id="dsib-handback-firewatch-name"
                      className="dsib-handBackPassModalInput"
                      type="text"
                      value={fireWatchCompletedBy || ''}
                      onChange={this.handleFireWatchNameChange}
                    />
                  </div>
                ) : null}
              </div>
            ) : null}

            <div className="dsib-handBackPassModalCta">
              <Button
                variant="primary"
                isFullWidth
                onClick={this.submitHandBackPass}
                disabled={this.enableButtonCheck()}
              >
                {`Hand back ${title}`}
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

HandBackPassModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  loadingCallback: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  visitId: PropTypes.number.isRequired,
  isPlural: PropTypes.bool.isRequired,
  workOrderNumber: PropTypes.string.isRequired,
  closeHandBackModal: PropTypes.func.isRequired,
  hasFireWatchHandbackQuestions: PropTypes.bool.isRequired
}

export default HandBackPassModal
